import createHistory from 'history/createBrowserHistory';


const configureHistory = (analyticsTracker) => {
  const history = createHistory();

  if (typeof analyticsTracker === 'function') {
    analyticsTracker(history.location);
    history.listen(analyticsTracker);
  }

  return history;
};


export default configureHistory;
